import { BsTruck } from "react-icons/bs";
import {
  FaFacebook,
  FaMapPin,
  FaPhoneAlt,
  FaWhatsapp,
} from "react-icons/fa";
import { useSettings } from "context/SettingsContext";
import { t } from "context/translations";
import {
  CONTACT_INFO,
  getTelHref,
  getWhatsAppHref,
} from "constants/contactInfo";

const ProblemAndDelivery = ({ whatsappMessage, className = "" }) => {
  const { theme, language } = useSettings();
  const isDark = theme === "dark";

  return (
    <aside className={`w-full ${className}`}>
      <div className="space-y-4">
        <div
          lang="bn"
          className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm"
        >
          <div className="px-4 py-4 text-center md:px-5 md:py-5">
            <p
              className={`text-sm font-semibold md:text-base ${isDark ? "text-white" : "text-gray-800"}`}
            >
              {t("problemWithOrder", language)}
            </p>

            <p className="mt-1 text-xs text-gray-500 md:text-sm">
              {t("contactWithUs", language)}
            </p>

            <div className="mt-3 flex flex-col gap-2 sm:flex-row sm:justify-center">
              <a
                href={getWhatsAppHref(
                  CONTACT_INFO.phone.whatsapp,
                  whatsappMessage,
                )}
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                <div className="flex w-full items-center justify-center gap-2 rounded-full border border-green-400 bg-green-100 px-4 py-3 text-sm font-semibold text-green-800 shadow-md transition-all duration-300 md:text-base">
                  <FaWhatsapp className="text-xl" />
                  {t("orderOnWhatsapp", language)}
                </div>
              </a>
              <a
                href={getTelHref(CONTACT_INFO.phone.tel)}
                className="flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-primary-500 via-primary-600 to-primary-800 px-4 py-3 text-sm font-semibold text-white shadow-md transition-all duration-300 hover:scale-[1.03] hover:shadow-lg md:text-base"
              >
                <FaPhoneAlt className="text-xl" /> {t("callNow", language)}
              </a>
            </div>
          </div>
        </div>

        <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="bg-gradient-to-r from-gray-100 to-gray-50 px-4 py-3">
            <p className="text-sm font-semibold text-gray-800 md:text-base">
              🛒 {t("deliveryOptions", language)}
            </p>
          </div>

          <div className="space-y-2 p-4">
            <div className="flex cursor-pointer items-center justify-between rounded-xl bg-green-50 p-3 transition-all duration-300 hover:bg-green-100">
              <div className="flex items-center gap-3">
                <div className="rounded-xl bg-white p-2 text-green-600 shadow-sm">
                  <FaMapPin size={18} />
                </div>

                <div>
                  <p className="text-sm font-semibold text-gray-800">
                    {t("insideDhaka", language)}
                  </p>
                  <p className="text-xs text-gray-500">
                    {t("deliveryWithin24Hours", language)}
                  </p>
                </div>
              </div>

              <span className="rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-600">
                {t("fast", language)}
              </span>
            </div>

            <div className="flex cursor-pointer items-center justify-between rounded-xl bg-primary-50 p-3 transition-all duration-300 hover:bg-primary-100">
              <div className="flex items-center gap-3">
                <div className="rounded-xl bg-white p-2 text-primary-600 shadow-sm">
                  <BsTruck size={18} />
                </div>

                <div>
                  <p className="text-sm font-semibold text-gray-800">
                    {t("outsideDhaka", language)}
                  </p>
                  <p className="text-xs text-gray-500">
                    {t("deliveryWithin2Hours", language)}
                  </p>
                </div>
              </div>

              <span className="rounded-full bg-primary-100 px-2 py-1 text-xs font-medium text-primary-600">
                {t("standard", language)}
              </span>
            </div>
          </div>
        </div>

        <div className="rounded-2xl border border-gray-200 bg-gray-100 px-5 py-4 text-center shadow-sm">
          <p
            className={`text-base font-semibold md:text-lg ${isDark ? "text-white" : "text-gray-800"}`}
          >
            {t("connectWithUs", language)}
          </p>

          <p className="mt-1 text-xs text-gray-500">
            {t("followUsOnSocialMedia", language)}
          </p>

          <div className="mt-4 mb-2 flex flex-wrap justify-center gap-3">
            <a
              href={CONTACT_INFO.social.facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="group rounded-xl bg-primary-50 p-3 text-primary-600 transition-all duration-300 hover:scale-110 hover:bg-primary-600 hover:text-white hover:shadow-lg"
            >
              <FaFacebook className="text-xl" />
            </a>

            <a
              href={getWhatsAppHref(CONTACT_INFO.phone.whatsapp)}
              target="_blank"
              rel="noopener noreferrer"
              className="group rounded-xl bg-green-50 p-3 text-green-600 transition-all duration-300 hover:scale-110 hover:bg-green-600 hover:text-white hover:shadow-lg"
            >
              <FaWhatsapp className="text-xl" />
            </a>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default ProblemAndDelivery;
